import { useId, type SVGProps } from "react";
import { cn } from "@hero-app/lib/utils";

export interface IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function DashboardIcon({ className, ...props }: IconProps) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="10"
        height="10"
      >
        <rect width="10" height="10" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M2.08333 8.75C1.85417 8.75 1.65799 8.6684 1.49479 8.50521C1.3316 8.34201 1.25 8.14583 1.25 7.91667V2.08333C1.25 1.85417 1.3316 1.65799 1.49479 1.49479C1.65799 1.3316 1.85417 1.25 2.08333 1.25H7.91667C8.14583 1.25 8.34201 1.3316 8.50521 1.49479C8.6684 1.65799 8.75 1.85417 8.75 2.08333V7.91667C8.75 8.14583 8.6684 8.34201 8.50521 8.50521C8.34201 8.6684 8.14583 8.75 7.91667 8.75H2.08333ZM3.33333 7.91667V2.08333H2.08333V7.91667H3.33333ZM4.16667 7.91667H7.91667V2.08333H4.16667V7.91667Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function ProjectsIcon({ className, ...props }: IconProps) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="10"
        height="10"
      >
        <rect width="10" height="10" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M2.08334 9.16671C1.73612 9.16671 1.44098 9.04518 1.19793 8.80212C0.954871 8.55907 0.833344 8.26393 0.833344 7.91671C0.833344 7.64587 0.911469 7.40455 1.06772 7.19275C1.22397 6.98094 1.42362 6.8299 1.66668 6.73962V3.26046C1.42362 3.17018 1.22397 3.01914 1.06772 2.80733C0.911469 2.59553 0.833344 2.35421 0.833344 2.08337C0.833344 1.73615 0.954871 1.44101 1.19793 1.19796C1.44098 0.954902 1.73612 0.833374 2.08334 0.833374C2.35418 0.833374 2.5955 0.911499 2.8073 1.06775C3.01911 1.224 3.17015 1.42365 3.26043 1.66671H6.73959C6.82293 1.42365 6.9705 1.224 7.1823 1.06775C7.39411 0.911499 7.6389 0.833374 7.91668 0.833374C8.2639 0.833374 8.55904 0.954902 8.80209 1.19796C9.04515 1.44101 9.16668 1.73615 9.16668 2.08337C9.16668 2.36115 9.08855 2.60594 8.9323 2.81775C8.77605 3.02955 8.5764 3.17712 8.33334 3.26046V6.73962C8.5764 6.8299 8.77605 6.98094 8.9323 7.19275C9.08855 7.40455 9.16668 7.64587 9.16668 7.91671C9.16668 8.26393 9.04515 8.55907 8.80209 8.80212C8.55904 9.04518 8.2639 9.16671 7.91668 9.16671C7.64584 9.16671 7.40452 9.08858 7.19272 8.93233C6.98091 8.77608 6.82987 8.57643 6.73959 8.33337H3.26043C3.17015 8.57643 3.01911 8.77608 2.8073 8.93233C2.5955 9.08858 2.35418 9.16671 2.08334 9.16671ZM2.08334 2.50004C2.2014 2.50004 2.30036 2.46011 2.38022 2.38025C2.46008 2.30039 2.50001 2.20143 2.50001 2.08337C2.50001 1.96532 2.46008 1.86636 2.38022 1.7865C2.30036 1.70664 2.2014 1.66671 2.08334 1.66671C1.96529 1.66671 1.86633 1.70664 1.78647 1.7865C1.70661 1.86636 1.66668 1.96532 1.66668 2.08337C1.66668 2.20143 1.70661 2.30039 1.78647 2.38025C1.86633 2.46011 1.96529 2.50004 2.08334 2.50004ZM7.91668 2.50004C8.03473 2.50004 8.13369 2.46011 8.21355 2.38025C8.29341 2.30039 8.33334 2.20143 8.33334 2.08337C8.33334 1.96532 8.29341 1.86636 8.21355 1.7865C8.13369 1.70664 8.03473 1.66671 7.91668 1.66671C7.79862 1.66671 7.69966 1.70664 7.6198 1.7865C7.53994 1.86636 7.50001 1.96532 7.50001 2.08337C7.50001 2.20143 7.53994 2.30039 7.6198 2.38025C7.69966 2.46011 7.79862 2.50004 7.91668 2.50004ZM3.26043 7.50004H6.73959C6.80209 7.31949 6.89932 7.16324 7.03126 7.03129C7.1632 6.89935 7.31945 6.80212 7.50001 6.73962V3.26046C7.31945 3.19796 7.1632 3.10074 7.03126 2.96879C6.89932 2.83685 6.80209 2.6806 6.73959 2.50004H3.26043C3.19793 2.6806 3.1007 2.83685 2.96876 2.96879C2.83682 3.10074 2.68057 3.19796 2.50001 3.26046V6.73962C2.68057 6.80212 2.83682 6.89935 2.96876 7.03129C3.1007 7.16324 3.19793 7.31949 3.26043 7.50004ZM7.91668 8.33337C8.03473 8.33337 8.13369 8.29344 8.21355 8.21358C8.29341 8.13372 8.33334 8.03476 8.33334 7.91671C8.33334 7.79865 8.29341 7.69969 8.21355 7.61983C8.13369 7.53997 8.03473 7.50004 7.91668 7.50004C7.79862 7.50004 7.69966 7.53997 7.6198 7.61983C7.53994 7.69969 7.50001 7.79865 7.50001 7.91671C7.50001 8.03476 7.53994 8.13372 7.6198 8.21358C7.69966 8.29344 7.79862 8.33337 7.91668 8.33337ZM2.08334 8.33337C2.2014 8.33337 2.30036 8.29344 2.38022 8.21358C2.46008 8.13372 2.50001 8.03476 2.50001 7.91671C2.50001 7.79865 2.46008 7.69969 2.38022 7.61983C2.30036 7.53997 2.2014 7.50004 2.08334 7.50004C1.96529 7.50004 1.86633 7.53997 1.78647 7.61983C1.70661 7.69969 1.66668 7.79865 1.66668 7.91671C1.66668 8.03476 1.70661 8.13372 1.78647 8.21358C1.86633 8.29344 1.96529 8.33337 2.08334 8.33337Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function OrganizationIcon({ className, ...props }: IconProps) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="10"
        height="10"
      >
        <rect width="10" height="10" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M4.58334 7.08329H7.91668V6.85413C7.91668 6.54163 7.7639 6.29336 7.45834 6.10933C7.15279 5.92531 6.75001 5.83329 6.25001 5.83329C5.75001 5.83329 5.34723 5.92531 5.04168 6.10933C4.73612 6.29336 4.58334 6.54163 4.58334 6.85413V7.08329ZM6.83855 5.17183C7.00175 5.00864 7.08334 4.81246 7.08334 4.58329C7.08334 4.35413 7.00175 4.15795 6.83855 3.99475C6.67536 3.83156 6.47918 3.74996 6.25001 3.74996C6.02084 3.74996 5.82466 3.83156 5.66147 3.99475C5.49827 4.15795 5.41668 4.35413 5.41668 4.58329C5.41668 4.81246 5.49827 5.00864 5.66147 5.17183C5.82466 5.33503 6.02084 5.41663 6.25001 5.41663C6.47918 5.41663 6.67536 5.33503 6.83855 5.17183ZM1.66668 8.33329C1.43751 8.33329 1.24133 8.2517 1.07814 8.0885C0.914941 7.92531 0.833344 7.72913 0.833344 7.49996V2.49996C0.833344 2.27079 0.914941 2.07461 1.07814 1.91142C1.24133 1.74822 1.43751 1.66663 1.66668 1.66663H4.16668L5.00001 2.49996H8.33334C8.56251 2.49996 8.75869 2.58156 8.92189 2.74475C9.08508 2.90795 9.16668 3.10413 9.16668 3.33329V7.49996C9.16668 7.72913 9.08508 7.92531 8.92189 8.0885C8.75869 8.2517 8.56251 8.33329 8.33334 8.33329H1.66668ZM1.66668 7.49996H8.33334V3.33329H4.65626L3.82293 2.49996H1.66668V7.49996Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function SettingsIcon({ className, ...props }: IconProps) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="10"
        height="10"
      >
        <rect width="10" height="10" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M2.08333 8.33329V5.41663H1.25V4.58329H3.75V5.41663H2.91667V8.33329H2.08333ZM2.08333 3.74996V1.66663H2.91667V3.74996H2.08333ZM3.75 3.74996V2.91663H4.58333V1.66663H5.41667V2.91663H6.25V3.74996H3.75ZM4.58333 8.33329V4.58329H5.41667V8.33329H4.58333ZM7.08333 8.33329V7.08329H6.25V6.24996H8.75V7.08329H7.91667V8.33329H7.08333ZM7.08333 5.41663V1.66663H7.91667V5.41663H7.08333Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function InfoIcon({ className, ...props }: IconProps) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <g opacity="0.3">
        <mask
          id={maskId}
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="10"
          height="10"
        >
          <rect width="10" height="10" fill="#D9D9D9" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M4.70308 3.03646C4.62322 3.11632 4.58329 3.21528 4.58329 3.33334C4.58329 3.45139 4.62322 3.55035 4.70308 3.63021C4.78295 3.71007 4.8819 3.75001 4.99996 3.75001C5.11802 3.75001 5.21697 3.71007 5.29683 3.63021C5.3767 3.55035 5.41663 3.45139 5.41663 3.33334C5.41663 3.21528 5.3767 3.11632 5.29683 3.03646C5.21697 2.9566 5.11802 2.91667 4.99996 2.91667C4.8819 2.91667 4.78295 2.9566 4.70308 3.03646ZM5.41663 4.58334L4.58329 4.58334L4.58329 7.08334L5.41663 7.08334L5.41663 4.58334ZM4.99996 0.833339C5.57635 0.833339 6.11802 0.942714 6.62496 1.16146C7.1319 1.38021 7.57288 1.67709 7.94788 2.05209C8.32288 2.42709 8.61975 2.86806 8.8385 3.37501C9.05725 3.88195 9.16663 4.42362 9.16663 5.00001C9.16663 5.57639 9.05725 6.11806 8.8385 6.62501C8.61975 7.13195 8.32288 7.57292 7.94788 7.94792C7.57288 8.32292 7.1319 8.6198 6.62496 8.83855C6.11802 9.0573 5.57635 9.16667 4.99996 9.16667C4.42357 9.16667 3.8819 9.0573 3.37496 8.83855C2.86801 8.6198 2.42704 8.32292 2.05204 7.94792C1.67704 7.57292 1.38017 7.13195 1.16142 6.62501C0.942668 6.11806 0.833293 5.57639 0.833293 5.00001C0.833293 4.42362 0.942668 3.88195 1.16142 3.375C1.38017 2.86806 1.67704 2.42709 2.05204 2.05209C2.42704 1.67709 2.86802 1.38021 3.37496 1.16146C3.8819 0.942714 4.42357 0.833339 4.99996 0.833339ZM4.99996 1.66667C4.0694 1.66667 3.28121 1.98959 2.63538 2.63542C1.98954 3.28126 1.66663 4.06945 1.66663 5.00001C1.66663 5.93056 1.98954 6.71876 2.63538 7.36459C3.28121 8.01042 4.0694 8.33334 4.99996 8.33334C5.93052 8.33334 6.71871 8.01042 7.36454 7.36459C8.01038 6.71876 8.33329 5.93056 8.33329 5.00001C8.33329 4.06945 8.01038 3.28126 7.36454 2.63542C6.71871 1.98959 5.93052 1.66667 4.99996 1.66667Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
    </svg>
  );
}

export function StocksUpIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 6 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <path
        d="M2.62204 1.43644C2.82142 1.2062 3.17858 1.2062 3.37796 1.43644L4.88159 3.17267C5.16203 3.4965 4.932 4 4.50363 4H1.49637C1.068 4 0.837972 3.4965 1.11841 3.17267L2.62204 1.43644Z"
        fill="#16A34A"
      />
    </svg>
  );
}

export function StocksDownIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 6 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
      {...props}
    >
      <path
        d="M3.37796 4.56356C3.17858 4.79379 2.82142 4.79379 2.62204 4.56356L1.11841 2.82733C0.837972 2.5035 1.068 2 1.49637 2L4.50363 2C4.932 2 5.16203 2.5035 4.88159 2.82733L3.37796 4.56356Z"
        fill="#EF446F"
      />
    </svg>
  );
}
